import "./css/Icon.scss";

interface IParams {
    className?: string;
    name: string;
    size?: "small" | "medium" | "large";
}

export const Icon = (props: IParams) => {
    const { name, className } = props;
    const setIconSize = () => {
        switch (props.size) {
            case "small":
                return "20";
            case "medium":
                return "40";
            case "large":
                return "60";
            default:
                return "30";
        }
    };

    const size = `${setIconSize()}px`;

    return (
        <svg className={className ?? "icon-grey"} height={size} width={size}>
            <use href={`/img/sprite.svg#${name}`} />
        </svg>
    );
};
